// We still need this barrel file to support Dato-entered icons
// (e.g. Button, ListWithIcons)
export * from 'react-feather';
export * from './ai';

//# sourceMappingURL=index.js.map